"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberToDayAfterName = void 0;
const numberToDayAfterName = (number) => {
    if (number === 0) {
        return '当日';
    }
    if (number === 1) {
        return '翌日';
    }
    if (number % 7 === 0) {
        return `${number / 7}週間後`;
    }
    return `${number}日後`;
};
exports.numberToDayAfterName = numberToDayAfterName;
//# sourceMappingURL=numberToDayName.js.map